var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.582036 0.207854C0.584654 0.2122 2.25143 2.45161 4.28599 5.18431C7.40987 9.38012 7.98356 10.1549 7.97471 10.1661C7.96895 10.1734 6.38945 12.028 4.46472 14.2875L0.965203 18.3956L2.46304 18.3978C3.28684 18.3991 3.96533 18.3983 3.97079 18.3962C3.97624 18.3941 5.19203 16.9702 6.67252 15.232C8.15301 13.4938 9.3708 12.0645 9.3787 12.0559C9.39239 12.0409 9.50633 12.1923 11.761 15.2201L14.1289 18.4H17.1554H20.182L20.1325 18.3327C18.8289 16.5643 12.4779 7.93685 12.4703 7.92419C12.46 7.90727 12.6791 7.64803 15.7375 4.05797C17.5405 1.94152 19.0157 0.207655 19.0157 0.204922C19.0157 0.202189 18.3402 0.199951 17.5144 0.199951H16.0131L13.5554 3.08533C12.2037 4.67228 11.09 5.98039 11.0805 5.99224L11.0634 6.01377L9.91129 4.4493C9.27764 3.58885 8.31432 2.28075 7.77058 1.5424L6.78196 0.199951H3.67962C1.81534 0.199951 0.579181 0.203109 0.582036 0.207854ZM10.6265 8.40643C13.2387 11.9538 15.6569 15.2378 16.0002 15.7042L16.6246 16.5522H15.7938H14.9629L14.6059 16.0729C14.4096 15.8093 13.7605 14.9378 13.1636 14.1362C11.691 12.1587 9.97247 9.85101 6.2286 4.82369C5.15378 3.3804 4.23304 2.14387 4.18252 2.07586L4.09066 1.95221L4.98386 1.95441L5.87707 1.95662L10.6265 8.40643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.59eca4bc9abf0b28696a18268bf93bf7.svg";
export { ForwardRef as ReactComponent };